/* global grecaptcha, AppData */
/* eslint no-undef: "error" */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { capi } from '../../client';

const getDefaultState = () => ({
  emailSuccessFlag: null,
  emailErrorResponse: null,
  recaptchaSuccess: null,
});

export default {
  namespaced: true,

  state: {
    ...getDefaultState(),
  },

  getters: {
    emailSuccessFlag: (state) => state.emailSuccessFlag,
    emailErrorResponse: (state) => state.emailErrorResponse,
    recaptchaSuccess: (state) => state.recaptchaSuccess,

    /**
     * Determines whether or not the email is disabled for the current product
     * @returns {boolean} indicating whether or not the email is disabled
     */
    isEmailDisabledForProduct: (state, getters, rootState, rootGetters) => {
      if (!rootGetters.noProductFlowFlag) {
        // eslint-disable-next-line dot-notation
        const { disableEmail } = rootGetters['product'];
        if (typeof disableEmail !== 'undefined' && disableEmail) {
          return true;
        }
      }
      return false;
    },

  },

  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    setEmailSuccessFlag(state, flag) {
      state.emailSuccessFlag = flag;
    },
    setEmailErrorResponse(state, response) {
      state.emailErrorResponse = response;
    },
    setRecaptchaSuccess(state, success) {
      state.recaptchaSuccess = success;
    },
  },

  actions: {
    reset({ commit }) {
      commit('reset');
    },

    resetEmailErrorResponse({ commit }) {
      commit('setEmailErrorResponse', null);
    },

    resetEmailSuccessFlag({ commit }) {
      commit('setEmailSuccessFlag', null);
    },
    async sendEmail({
      state, getters, commit, rootGetters,
    }, payload) {
      const apiId = 'sendEmail';
      if (rootGetters[`isApiIdCallInProgress(${apiId})`]) return;
      commit('incrementApiCallsInProgress', apiId, { root: true });

      try {
        if (typeof grecaptcha === 'undefined') throw new Error('grecaptcha is not defined');
        const recaptchaToken = await grecaptcha.execute(AppData.recaptchaClientKey, { action: 'Send_Email_Form' });
        const { status } = await capi.post('sendEmail', { payload, recaptchaToken });
        if (status === 200) {
          commit('setEmailSuccessFlag', true);
          commit('setEmailErrorResponse', null);
        } else commit('setEmailSuccessFlag', false);
      } catch (e) {
        const { response: { data } } = e;
        commit('setEmailSuccessFlag', false);

        if (data && Array.isArray(data) && data.length > 0) {
          commit('setEmailErrorResponse', data);
        } else commit('setEmailErrorResponse', null);
      } finally {
        commit('decrementApiCallsInProgress', apiId, { root: true });
      }
    },

    verifyRecaptcha({ commit }, actionIdentifier) {
      if (typeof grecaptcha === 'undefined') return;
      grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(AppData.recaptchaClientKey, {
          action: actionIdentifier,
        });
        const { data: { success } } = await capi.post(`recaptcha/verify/?response=${token}`, {});
        commit('setRecaptchaSuccess', success);
      });
    },
  },
};
